// extracted by mini-css-extract-plugin
export var grid = "_1y-0";
export var span1 = "_1y-2";
export var span10 = "_1y-b";
export var span10L = "_1y-z";
export var span10M = "_1y-n";
export var span10Xl = "_1y-1b";
export var span11 = "_1y-c";
export var span11L = "_1y-10";
export var span11M = "_1y-o";
export var span11Xl = "_1y-1c";
export var span12 = "_1y-d";
export var span12L = "_1y-11";
export var span12M = "_1y-p";
export var span12Xl = "_1y-1d";
export var span1L = "_1y-q";
export var span1M = "_1y-e";
export var span1Xl = "_1y-12";
export var span2 = "_1y-3";
export var span2L = "_1y-r";
export var span2M = "_1y-f";
export var span2Xl = "_1y-13";
export var span3 = "_1y-4";
export var span3L = "_1y-s";
export var span3M = "_1y-g";
export var span3Xl = "_1y-14";
export var span4 = "_1y-5";
export var span4L = "_1y-t";
export var span4M = "_1y-h";
export var span4Xl = "_1y-15";
export var span5 = "_1y-6";
export var span5L = "_1y-u";
export var span5M = "_1y-i";
export var span5Xl = "_1y-16";
export var span6 = "_1y-7";
export var span6L = "_1y-v";
export var span6M = "_1y-j";
export var span6Xl = "_1y-17";
export var span7 = "_1y-8";
export var span7L = "_1y-w";
export var span7M = "_1y-k";
export var span7Xl = "_1y-18";
export var span8 = "_1y-9";
export var span8L = "_1y-x";
export var span8M = "_1y-l";
export var span8Xl = "_1y-19";
export var span9 = "_1y-a";
export var span9L = "_1y-y";
export var span9M = "_1y-m";
export var span9Xl = "_1y-1a";
export var stretch = "_1y-1";